import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import MerchantLayout from '../../../layout/MerchantLayout';
import Typography from '@material-ui/core/Typography';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Button, Container, CssBaseline, Grid, Paper, TextField } from '@material-ui/core';
import { SimpleMerchantSignup } from '../../../types/merchant';
import { signupMerchant } from '../../../services/c2dcrm';

const useStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    placeItems: 'center',
    textAlign: 'center',
  },
  header: {
    display: 'grid',
    gridGap: '16px',
    marginTop: '10px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  emailWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '40px',
  },
});

const MerchantSignupStart: React.FC = () => {
  const classes = useStyles();
  const { register, handleSubmit } = useForm<SimpleMerchantSignup>();
  const [errorMessage, setErrorMessage] = useState('');
  const [errorResponse, setErrorResponse] = useState('');
  const [success, setSuccess] = useState(false);

  const onSubmit: SubmitHandler<SimpleMerchantSignup> = async (data: SimpleMerchantSignup) => {
    signupMerchant(data).then((response) => {
      if (response.status === 200) {
        setSuccess(true);
      }
      else {
        setSuccess(false);
      }
    }).catch(function (error) {
      setErrorResponse(error);
      setErrorMessage("This email is already registered as a merchant.");
    })
  };

  return (
    <Container maxWidth="sm">
      <MerchantLayout>
        <CssBaseline />
        <Paper className={classes.container}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Grid item xs={12} style={{ padding: '10px' }}>
              <Typography variant="h2" color="primary">
                Merchant Signup
              </Typography>
            </Grid>

            <Grid item xs={12} style={{ padding: '20px' }}>
              <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '30px' }}>
                <TextField
                  key="2"
                  id="email"
                  style={{ width: '100%' }}
                  label="Email"
                  defaultValue=''
                  {...register('email', { required: true })}
                  onFocus={() => {
                    setErrorMessage('');
                    setErrorResponse('');
                  }}
                />

                {!errorMessage ? <Button type="submit">Sign up!</Button> : errorMessage}
                {errorResponse ? errorMessage : <></>}
              </form>
            </Grid>
            {success &&
              <Grid item xs={12} style={{ marginBottom: '30px' }}>
                Thank you for signing up, please look out for an email for the next step.
              </Grid>
            }
          </Grid>
        </Paper>
      </MerchantLayout>
    </Container>
  );
};

export default MerchantSignupStart;
